/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbUsersCentresLiesDto
 */
export interface FcbUsersCentresLiesDto {
    /**
     * 
     * @type {number}
     * @memberof FcbUsersCentresLiesDto
     */
    idUser?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof FcbUsersCentresLiesDto
     */
    idsCentres?: Array<number> | null;
}

/**
 * Check if a given object implements the FcbUsersCentresLiesDto interface.
 */
export function instanceOfFcbUsersCentresLiesDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbUsersCentresLiesDtoFromJSON(json: any): FcbUsersCentresLiesDto {
    return FcbUsersCentresLiesDtoFromJSONTyped(json, false);
}

export function FcbUsersCentresLiesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbUsersCentresLiesDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idUser': !exists(json, 'idUser') ? undefined : json['idUser'],
        'idsCentres': !exists(json, 'idsCentres') ? undefined : json['idsCentres'],
    };
}

export function FcbUsersCentresLiesDtoToJSON(value?: FcbUsersCentresLiesDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idUser': value.idUser,
        'idsCentres': value.idsCentres,
    };
}

